import { Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { AccommodationQuery } from './__generated__/show_query'
import { PencilIcon } from '@heroicons/react/24/solid'
import { Tabs } from '@/components/tabs'
import { Form as DetailsForm } from '@/components/accommodation/edit_form'
import { EditContacts as EditContactForm } from './edit_contacts'
import { EditRoomTypes as EditRoomTypeForm } from './edit_room_types'

type Accommodation = AccommodationQuery['accommodations']['nodes'][0]

interface Props {
  accommodation: Accommodation
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const EditDialog = ({ accommodation, open, setOpen }: Props) => {
  const tabs = [
    { name: 'Details', component: <DetailsForm id={accommodation.id} />, icon: PencilIcon },
    { name: 'Contacts', component: <EditContactForm id={accommodation.id} />, icon: PencilIcon },
    { name: 'Room types', component: <EditRoomTypeForm id={accommodation.id} />, icon: PencilIcon }

  ]

  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle><div>{ accommodation.name }</div></DialogTitle>
        <DialogBody>
          <Tabs tabs={tabs} />
        </DialogBody>
      </Dialog>
    </>
  )
}
